/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function List(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66602 14.167C7.58638 14.167 8.33283 14.9127 8.33301 15.833C8.33301 16.7535 7.58649 17.5 6.66602 17.5C5.74563 17.4999 5 16.7534 5 15.833C5.00018 14.9127 5.74574 14.1671 6.66602 14.167ZM12.916 14.167C13.8364 14.167 14.5828 14.9127 14.583 15.833C14.583 16.7535 13.8365 17.5 12.916 17.5C11.9956 17.4999 11.25 16.7534 11.25 15.833C11.2502 14.9127 11.9957 14.1671 12.916 14.167ZM6.66602 8.33301C7.58649 8.33301 8.33301 9.07952 8.33301 10C8.33301 10.9205 7.58649 11.667 6.66602 11.667C5.74563 11.6669 5 10.9204 5 10C5 9.07959 5.74563 8.33311 6.66602 8.33301ZM12.916 8.33301C13.8365 8.33301 14.583 9.07952 14.583 10C14.583 10.9205 13.8365 11.667 12.916 11.667C11.9956 11.6669 11.25 10.9204 11.25 10C11.25 9.07959 11.9956 8.33311 12.916 8.33301ZM6.66602 2.5C7.58649 2.5 8.33301 3.24652 8.33301 4.16699C8.33283 5.08732 7.58638 5.83301 6.66602 5.83301C5.74574 5.8329 5.00018 5.08725 5 4.16699C5 3.24658 5.74563 2.50011 6.66602 2.5ZM12.916 2.5C13.8365 2.5 14.583 3.24652 14.583 4.16699C14.5828 5.08732 13.8364 5.83301 12.916 5.83301C11.9957 5.8329 11.2502 5.08725 11.25 4.16699C11.25 3.24658 11.9956 2.50011 12.916 2.5Z"
        fill="#13A0AA"
      />
    </svg>
  )
}

List.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default List
